import React from 'react';
import AcitonDialog from './AcitonDialog';
import { useAutoTranslation } from 'src/hooks/useTranslate';

/**
 * The "you have unsaved changes" confirmation shown when a clinical-record
 * modal is closed with edits pending.
 *
 * The wording and the Cancel / Discard changes pair are lifted verbatim from
 * the clinical-notes section (ClinicalNotes.jsx), which has warned on close
 * since long before this component existed. The disease, phenotype and genotype
 * modals were the three that never did — a clinician could type an age, hit the
 * X, and lose it silently.
 *
 * `onDiscard` must close the record for real. Every caller pairs it with a
 * reset, because these modals stay mounted after closing and would otherwise
 * show the discarded values again on the next open.
 */
export default function UnsavedChangesDialog({ open, onCancel, onDiscard }) {
  const t = useAutoTranslation();

  return (
    <AcitonDialog
      open={open}
      title={t('Unsaved Changes')}
      saveText={t('Discard changes')}
      handleClose={onCancel}
      onSubmit={onDiscard}
    >
      {t(
        'You have unsaved changes that will be lost if you continue. Would you like to discard your changes and proceed anyway?'
      )}
    </AcitonDialog>
  );
}
